import actions from './actions';

const initialState = {
  codeSnippetDetails: {
    metadata: {
      heading: 'API Code Snippet'
    },
    code: '',
  },
};

const { GET_CODE_SNIPPET_SUCCESS, GET_CODE_SNIPPET_ERR, SET_CODE_SNIPPET_SUCCESS, SET_CODE_SNIPPET_ERR } = actions;

const codeSnippetReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_CODE_SNIPPET_SUCCESS:
      return state;
    case GET_CODE_SNIPPET_ERR:
      return err;
    case SET_CODE_SNIPPET_ERR:
      return err;
    case SET_CODE_SNIPPET_SUCCESS:
      return {
        ...state,
        codeSnippetDetails: data,
      };
    default:
      return state;
  }
};

export { codeSnippetReducer };
